// Core imports
import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';
import * as ReactDOM from 'react-dom';
import env from 'src/shared/env';
import AddressModel from 'src/model/address.model';

// Components imports

// Models imports

// Style and misc imports

class CheckPrintable extends React.Component<ICheckPrintableProps, any> {
  private printWindow: Window;
  private container: HTMLDivElement;
  /* 
    getInvoicesToPay
   */
  private getInvoicesToPay = () => {
    const { t } = this.props;
    return (
      <table>
        <thead>
          <tr className="invoice">
            <td
              style={{
                padding: '0 8px',
                textTransform: 'capitalize',
                textAlign: 'left'
              }}
            >
              {' '}
            </td>
            <td style={{ padding: '0 8px' }}>{t('payment.check.amount')}</td>
            <td style={{ padding: '0 8px' }}>{t('payment.check.remaining')}</td>
            <td style={{ padding: '0 8px' }}>{t('payment.check.total')}</td>
            <td style={{ padding: '0 0 0 8px', textTransform: 'capitalize' }}>
              {t('common.notes')}
            </td>
          </tr>
        </thead>
        <tbody>
          {this.props.invoices.map((invoice, index) => {
            return (
              <tr className="invoice" key={index}>
                <td
                  style={{
                    padding: '0 8px',
                    textTransform: 'capitalize',
                    textAlign: 'left'
                  }}
                >
                  {t('invoices.invoice')}: {invoice.invoiceNumber}
                </td>
                <td style={{ padding: '0 8px', textAlign: 'right' }}>
                  {LocaleFormating.formatCurrency(invoice.payment)}
                </td>
                <td style={{ padding: '0 8px', textAlign: 'right' }}>
                  {LocaleFormating.formatCurrency(invoice.remaining)}
                </td>
                <td style={{ padding: '0 8px', textAlign: 'right' }}>
                  {LocaleFormating.formatCurrency(invoice.total)}
                </td>
                <td style={{ padding: '0 0 0 8px', textAlign: 'right' }}>
                  {invoice.notes}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  /* 
    getTotalOnCheck
   */
  private getTotalOnCheck = () => {
    let total: number = 0;
    this.props.invoices.forEach(invoice => {
      // I had to convert to string a number because TS was taking the number value as string.
      total += parseFloat(invoice.payment.toString());
    });
    return total;
  };

  /* 
    getPrintableCheck
   */
  private getPrintableCheck = () => {
    const { t } = this.props;
    return (
      <div>
        <div className="address" style={{ fontFamily: 'Times New Roman' }}>
          <p
            style={{
              display: 'flex',
              flexDirection: 'column',
              fontWeight: 'bold',
              margin: '130px 0 30px 0'
            }}
          >
            <span>Reliable Parts</span>
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
              <React.Fragment>
                <span>85 North Bend Street</span>
                <span>Coquitlam BC.,</span>
                <span>V3K 6N1</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>P.O. Box 566268</span>
                <span>Dallas, Texas 75356</span>
              </React.Fragment>
            )}
          </p>
          <p
            style={{
              fontWeight: 'bold',
              margin: '0px 0 130px 0'
            }}
          >
            Account: {this.props.userAccount}
            <br />
            {this.props.user?.billingAddress
              ? this.props.user?.billingAddress?.name
              : ''}
            <br />
            {this.props.user && this.props.user.billingAddress
              ? this.formatAddress(this.props.user.billingAddress)
              : ''}
          </p>
        </div>
        <div className="alert">
          <p>
            <span style={{ fontWeight: 'bold' }}>
              {t('payment.check.note')}
            </span>{' '}
            <span>
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? t('payment.checkCA.paymentAlert')
                : t('payment.check.paymentAlert')}
            </span>
          </p>
        </div>
        <div className="payment" style={{ margin: '0 0 32px 0' }}>
          {this.getInvoicesToPay()}
        </div>
        <div className="total">
          <span
            style={{
              fontWeight: 'bold',
              fontSize: '26px',
              textTransform: 'capitalize'
            }}
          >
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
              ? t('payment.checkCA.totalOnCheck')
              : t('payment.check.totalOnCheck')}
            : {LocaleFormating.formatCurrency(this.getTotalOnCheck())}
          </span>
        </div>
        <div className="alert">
          <p>
            <span>{t('payment.check.thanks')}</span>
          </p>
        </div>
      </div>
    );
  };

  public componentWillMount() {
    this.printWindow = window.open('', '', 'width=800,height=600');
    const document = this.printWindow.document;

    this.container = document.createElement('div');
    document.body.appendChild(this.container);
    document.title =
      env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'Print Cheque' : 'Print Check';
  }

  public componentDidMount() {
    const fun = () => {
      process.nextTick(() => {
        this.props.closeWindow();
      });
      this.printWindow.removeEventListener('beforeunload', fun);
    };

    this.printWindow.addEventListener('beforeunload', fun);
    setTimeout(() => {
      this.printWindow.print();
      this.printWindow.close();
    }, 600);
  }

  public componentWillUnmount() {
    const ua = navigator.userAgent;
    if (
      ua.indexOf('MSIE ') > -1 ||
      ua.indexOf('Edge') > -1 ||
      ua.indexOf('Trident/') > -1
    ) {
      location.reload();
    } else {
      this.printWindow.close();
    }
  }
  public formatAddress(address: AddressModel) {
    return (
      <React.Fragment>
        {address.addressLine1 ? `${address.addressLine1},` : ''}{' '}
        {address.addressLine2 ? ` ${address.addressLine2} ` : ''}{' '}
        {address.addressLine3 ? ` ${address.addressLine3} ` : ''} <br />
        {address.addressLine4 ? ` ${address.addressLine4}, ` : ''}
        {address.stateCode ? `${address.stateCode}` : ''}{' '}
        {address.postalCode ? `${address.postalCode}` : ''}
      </React.Fragment>
    );
  }

  public render() {
    if (!this.container) {
      return null;
    }
    return ReactDOM.createPortal(this.getPrintableCheck(), this.container);
  }
}

export default CheckPrintable;

interface ICheckPrintableProps {
  closeWindow: () => void;
  t: any;
  invoices: IInvoicePrintable[];
  userAccount: string;
  user?: any;
}

interface IInvoicePrintable {
  invoiceNumber: number;
  payment: number;
  remaining: number;
  total: number;
  notes: string;
}

// interface ICheckPrintableState {}
